// Mock data for portfolio artwork
export const artworks = [
  {
    id: 1,
    title: "The Knight",
    slug: "the-knight",
    thumbnail: "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/1mgnlpcx_knight_1.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/1mgnlpcx_knight_1.jpg",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/5poydv5x_knight_2.jpg",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/wh3076um_knight_3.jpg",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/dg10e9px_knight_4.jpg",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/x8sxt3uv_Screenshot%202026-05-03%20190742.png",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/8auufi5k_Screenshot%202026-05-03%20190828.png",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/jm3p1vfn_Screenshot%202026-05-02%20220235.png",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/jszo3ds5_Screenshot%202026-05-02%20222100.png"
    ],
    description: "Character created in Zbrush and Blender. Textured in Substance Painter.",
    medium: "3D Character Design",
    software: ["ZBrush", "Blender", "Substance Painter"],
    references: ["https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/jszo3ds5_Screenshot%202026-05-02%20222100.png"]
  },
  {
    id: 2,
    title: "The Thief",
    slug: "the-thief",
    thumbnail: "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/vk2pyl94_sm_rogue_render_1.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/vk2pyl94_sm_rogue_render_1.jpg",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/jj2tkraz_sm_rogue_render_10.jpg",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/7q6p4mnf_Screenshot%202026-04-03%20144557.png",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/xsq6wdhw_Screenshot%202026-04-28%20134458.png",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/yz2riwqh_Screenshot%202026-05-02%20220516.png",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/qn1n9pgy_Screenshot%202026-05-02%20222242.png"
    ],
    description: "Character created in Zbrush and Blender. Textured in Substance Painter.",
    medium: "3D Character Design",
    software: ["ZBrush", "Blender", "Substance Painter"],
    references: ["https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/qn1n9pgy_Screenshot%202026-05-02%20222242.png"]
  },
  {
    id: 3,
    title: "The Reaver",
    slug: "the-reaver",
    thumbnail: "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/ewntruxt_Reaver_Post.png",
    images: [
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/sdhmbjd2_BubblesRend4.jpg",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/ewntruxt_Reaver_Post.png",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/l494tat1_Screenshot%202026-05-02%20214948.png",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/zfh33ggd_Screenshot%202026-05-02%20214332.png",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/rvbl5zy9_Screenshot%202026-05-02%20222140.png"
    ],
    description: "Character created in Zbrush and Blender. Textured in Substance Painter. Post Processing done in Photoshop.",
    medium: "3D Character Design",
    software: ["ZBrush", "Blender", "Substance Painter", "Photoshop"],
    references: ["https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/rvbl5zy9_Screenshot%202026-05-02%20222140.png"]
  },
  {
    id: 4,
    title: "Brawn (WIP)",
    slug: "brawn",
    thumbnail: "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/w5cyqcr0_Screenshot%202026-05-02%20223203.png",
    images: [
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/w5cyqcr0_Screenshot%202026-05-02%20223203.png",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/9i1w23e6_Screenshot%202026-05-02%20223226.png",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/74t13foy_Screenshot%202026-05-02%20223337.png"
    ],
    description: "Character created in Zbrush and Blender. Textured in Substance Painter.",
    medium: "3D Character Design",
    software: ["ZBrush", "Blender", "Substance Painter"],
    references: ["https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/74t13foy_Screenshot%202026-05-02%20223337.png"]
  },
  {
    id: 5,
    title: "Sunflower",
    slug: "sunflower",
    thumbnail: "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/i3vo6rlh_sunny%20-1.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/i3vo6rlh_sunny%20-1.jpg",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/rso95pmu_sunny%20-2.jpg",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/9532aegc_Screenshot%202026-05-02%20212558.png",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/t19p7d1q_Screenshot%202026-05-02%20212631.png"
    ],
    description: "Character created in Zbrush and Blender. Textured in Substance Painter.",
    medium: "3D Character Design",
    software: ["ZBrush", "Blender", "Substance Painter"]
  },
  {
    id: 6,
    title: "Laplace Diner",
    slug: "laplace-diner",
    thumbnail: "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/f0scd32d_long_orig.png",
    images: [
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/9l6yvw9t_flat.jpg",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/f0scd32d_long_orig.png",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/l2kjh433_white3_orig.png",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/d5hrh1ci_flat3.jpg"
    ],
    description: "3D hard surface environment",
    medium: "3D Environment Design",
    software: ["Blender", "Substance Painter"]
  },
  {
    id: 7,
    title: "The Guildmaster (WIP)",
    slug: "the-guildmaster",
    thumbnail: "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/2ranhnpd_guild_2.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/2ranhnpd_guild_2.jpg",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/hfhul16q_guild_3.jpg",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/3laxcrko_guild_4.jpg",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/kysmglv2_guild_5.jpg"
    ],
    description: "Character created in Zbrush and Blender. Textured in Substance Painter.",
    medium: "3D Character Design",
    software: ["ZBrush", "Blender", "Substance Painter"]
  },
  {
    id: 8,
    title: "Bruiser (WIP)",
    slug: "bruiser",
    thumbnail: "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/jl46j4m0_Screenshot%202026-05-02%20193357.png",
    images: [
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/jl46j4m0_Screenshot%202026-05-02%20193357.png",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/zlevh7ba_Screenshot%202026-05-03%20190156.png",
      "https://customer-assets.emergentagent.com/job_portfolio-gallery-157/artifacts/6easd1q1_Screenshot%202026-05-03%20190210.png"
    ],
    description: "3D character sculpt. (In Progress)",
    medium: "3D Character Design"
  }
];

export const aboutContent = {
  statement: "Art is my language for exploring the invisible threads that connect us to our environment, our emotions, and each other. Through my work, I seek to challenge perceptions and invite viewers into a dialogue between the conscious and subconscious realms.",
  bio: "Based in the heart of the creative district, I have been practicing as a visual artist for over a decade. My journey began with traditional mediums and has evolved to embrace contemporary techniques and digital innovation. I hold an MFA from the School of Visual Arts and have exhibited internationally in galleries across North America and Europe.",
  cv: [
    {
      category: "Solo Exhibitions",
      items: [
        "2024 - 'Liminal Spaces' - Contemporary Art Gallery, New York",
        "2023 - 'Reflections' - Modern Art Museum, San Francisco",
        "2022 - 'Between Worlds' - Gallery XYZ, Toronto"
      ]
    },
    {
      category: "Group Exhibitions",
      items: [
        "2024 - 'Emerging Voices' - International Art Fair, Miami",
        "2023 - 'Contemporary Visions' - Art Basel, Switzerland",
        "2022 - 'New Perspectives' - Whitney Biennial, New York"
      ]
    },
    {
      category: "Awards & Recognition",
      items: [
        "2024 - Emerging Artist Award, National Art Foundation",
        "2023 - Best in Show, Contemporary Art Competition",
        "2022 - Artist Residency Grant, Creative Arts Center"
      ]
    }
  ]
};

export const contactInfo = {
  email: "Aaronmwhite0925@gmail.com",
  social: {
    instagram: "@artistportfolio",
    twitter: "@artistportfolio",
    linkedin: "www.linkedin.com/in/aaron-white-113b39300"
  }
};